import Vue from 'vue';
import Vuetify from 'vuetify/lib'
// import 'vuetify/dist/vuetify.min.css';
// import zhHant from 'vuetify/lib/locale/zh-Hant';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    // options: { customProperties: true },
    dark: true,
    themes: {
      dark: {
        primary: '#009FA5', // #143b71、#254c83
        secondary: '#121212',
        accent: '#6394d7',
        error: '#ec5267',
        success: '#4CAF50',
        blue: '#06ABF0',
        warning: '#da8200',
        'line-theme': '#3AAE36',
        'primary-darken': '#182640',
        'dark0': '#eeeeee',
        'dark1': '#9c9c9c',
        'dark2': '#3a3a3a',
        'dark3': '#242526',
        'dark4': '#1E1E1E',
        'dark5': '#161616',
        // base: string
        // lighten5: string
        // lighten4: string
        // lighten3: string
        // lighten2: string
        // lighten1: string
        'drcell': '#3fc799',
        'error-darken': '#3a2225',
        'v-light': '#eee',
        'color-1': '#d6545c',
        'color-2': '#f98068',
        'color-3': '#f0c158',
        'color-4': '#98cb69',
        'color-5': '#00b69e',

        'pain-1': '#479fd1',
        'pain-2': '#98cb69',
        'pain-3': '#f0c158',
        'pain-4': '#f98068',
        'pain-5': '#d6545c',

        'level-1': '#49954c',
        'level-2': '#fff',
        'level-3': '#f0c158',
        'level-4': '#d6545c',

        'level-reverse-2': '#f0c158',
        'level-reverse-1': '#d6545c',

        'mark-warning': '#634d1e',
        'mark-danger': '#4a161e',

        'epro-basic': '#143b71',
        'epro-core': '#c4a215',

        'real-reply': '#ffdd73',
      }
    },
  },
  // lang: {
  //   locales: { zhHant },
  //   current: 'zhHant',
  // },
});
